define(["backbone", "messaging/messenger", "../baseModels/collaborationFeaturesModel"], function (
  Backbone,
  Messenger,
  CollaborationFeaturesModel,
) {
  "use strict";

  const CommentModel = {};

  CommentModel.comment = CollaborationFeaturesModel.base.extend({
    idAttribute: "id",
    defaults: {
      ckCommentId: "",
      content: "",
      ckThreadId: "",
    },
  });

  CommentModel.comments = Backbone.Collection.extend({
    model: CommentModel.comment,
  });

  CommentModel.thread = CollaborationFeaturesModel.base.extend({
    idAttribute: "id",
    defaults: {
      ckThreadId: "",
      templateId: 0,
    },
    comments: function (options) {
      const subModelOptions = Object.assign(
        {
          modelClass: CommentModel.comments,
          urlExtension: "/comments",
        },
        options,
      );
      this.commentsCol = this.getSubModel2(this.commentsCol, subModelOptions);
      return this.commentsCol;
    },
    parse: function (data) {
      if (data.comments) {
        const comments = this.comments({ doNotFetch: true });
        comments.reset(data.comments, { parse: true, silent: true });
        delete data.comments;
      }
      return data;
    },
    saveChildren: function (options) {
      this.saveSubModels(options);
    },
  });

  CommentModel.threads = Backbone.Collection.extend({
    model: CommentModel.thread,
  });

  return CommentModel;
});
